<template>
  <div>
    <app-autocomplete @afficherSlider="setSlider"/>
    <div class="section py-0 px-5">
      <b-tabs v-model="activeTab" position="is-centered is-small"
        class="block tabs-side" type="is-toggle" expanded>
        <b-tab-item label="Patrimoine" class="is-primary" />
        <b-tab-item label="Géo-marketing" class="is-primary" :disabled="!hasGeoMarketing" />
      </b-tabs>
    </div>
    <app-filtre-patrimoine v-if="activeTab === 0" :afficherSlider="afficherSlider"/>
    <app-filtres-geo-marketting v-if="activeTab === 1"
            :isochrone="isochrone"
            :address="address"
            :typeLayerGeoMarketing="typeLayerGeoMarketing"
            @update="update" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import filtreAutocomplete from './autocomplete';
import filtrePatrimoine from './filtrePatrimoine';
import filtresGeoMarketting from './filtresGeoMarketting';

const Numerique = createNamespacedHelpers('venteNumerique');
const User = createNamespacedHelpers('user');

export default {
  name: 'filtres',
  components: {
    appAutocomplete: filtreAutocomplete,
    appFiltrePatrimoine: filtrePatrimoine,
    appFiltresGeoMarketting: filtresGeoMarketting,
  },
  data() {
    return {
      activeTab: 0,
      afficherSlider: true,
    };
  },
  computed: {
    ...Numerique.mapGetters({
      address: 'address',
      getIsochrone: 'isochrone',
      getTypeLayerGeoMarketing: 'typeLayerGeoMarketing',
    }),
    ...User.mapGetters({
      hasGeoMarketing: 'hasGeoMarketing',
    }),
    isochrone: {
      get() {
        return this.getIsochrone;
      },
      set(value) {
        this.setIsochrone(value);
      },
    },
    typeLayerGeoMarketing: {
      get() {
        return this.getTypeLayerGeoMarketing;
      },
      set(value) {
        this.setTypeLayerGeoMarketing(value);
      },
    },
  },
  methods: {
    ...Numerique.mapMutations({
      setIsochrone: types.SET_ISOCHRONE,
      setTypeLayerGeoMarketing: types.SET_TYPE_LAYER_GEO_MARKETING,
    }),
    update(data) {
      this.isochrone = data.isochrone;
      this.typeLayerGeoMarketing = data.typeLayerGeoMarketing;
    },
    setSlider(afficherSlider) {
      this.afficherSlider = afficherSlider;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/filtres/filtre.vue